import * as GeneralRepository from "./general-repository";
import * as AseguradoProvider from "../providers/asegurado-provider";

export const obtenerAsegurado = async (idSolicitudMultiple) => {
    const response = await AseguradoProvider.obtenerAsegurado(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            asegurado: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerAsegurado(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    asegurado: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                asegurado: null
            }
        }
    }
}

export const guardarAsegurado = async (asegurado, param) => {
    let response = null
    if(asegurado.idAsegurado !== undefined && asegurado.idAsegurado !== null && asegurado.idAsegurado !== 0) {
        let aseguradoAux = param === 'firma' ? {
            ...asegurado,
            contacto: {
                ...asegurado.contacto,
                celular: null
            }
        } : asegurado
        response = await AseguradoProvider.actualizarAsegurado(asegurado.idSolicitudMultiple, aseguradoAux)
    } else {
        response = await AseguradoProvider.registrarAsegurado(asegurado.idSolicitudMultiple, asegurado)
    }

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            asegurado: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarAsegurado(asegurado)
            } else {
                return {
                    error: response.auditResponse,
                    asegurado: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                asegurado: null
            }
        }
    }
}

export const cargarArchivoAdjunto = async (idAsegurado, archivo) => {
    const response = await AseguradoProvider.cargarArchivoAdjunto(idAsegurado, archivo)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            archivo: response.entity.archivo
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await cargarArchivoAdjunto(idAsegurado, archivo)
            } else {
                return {
                    error: response.auditResponse,
                    archivo: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                archivo: null
            }
        }
    }
}